import { useEffect, useState } from 'react';
import { projectsApiKeyStore } from '../../../../api/projects-api-key-store';
import { LoadingIndicator } from '../../../../components/loading-indicator.component';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { Project, ProjectType } from '../../../../models/project';
import { BuildingUnitsListForm } from '../building-units-list.form';
import { SactteredLoTEditForm } from '../scattered-lot-edit.form';
import { TimeAndMaterialEditForm } from '../time-and-material-edit.form';

interface EditProjectBuildingTabProps {
  project: Project;
  projectRequestDetails?: any;
}

export const EditProjectBuildingTab = ({ project, projectRequestDetails }: EditProjectBuildingTabProps) => {
  const [scatteredSingleOrMultipleLot, setScatteredSingleOrMultipleLot] = useState<any>();

  const { isLoading, isFetching, data, refetch } = useLoadData<ApiResponse<any>>(
    projectRequestDetails?.requestType != 'mysi' ?
      projectsApiKeyStore.getProjectLotInfo(Number(project.projectID))
      : projectsApiKeyStore.getProjectLotInfoByRequestID(project.projectID, projectRequestDetails?.requestID, projectRequestDetails?.requestType)
  );

  // const { data: states } = useLoadData<ApiResponse<any>>(stateApiKeyStore.getStates());
  // const { data: states } = useLoadData<ApiResponse<any>>(stateApiKeyStore.getStates());

  useEffect(() => {
    if (data?.data?.singleOrMultiLots?.length > 0) {
      const updatedData = data?.data?.singleOrMultiLots?.map((lot: any) => ({
        ...lot,
        stateID: !lot?.stateID ? null : { stateID: lot?.stateID },
        municipalityID: !lot?.municipalityID ? null : { municipalityID: lot?.municipalityID },
        // countyID: { countyID: lot?.countyID },
      }));

      setScatteredSingleOrMultipleLot(updatedData);
    }
  }, [data?.data]);

  if (isLoading || isFetching) {
    return <LoadingIndicator isLoading={isLoading || isFetching} />;
  }

  if (project.projectType === ProjectType.TimeAndMaterial) {
    return (
      <TimeAndMaterialEditForm
        projectID={project.projectID}
        syncWithDux={project?.projectSyncWithDUX}
        projectTypeValue={project?.projectType ?? ""}
        singleOrMultiLots={data?.data.singleOrMultiLots}
        isTimeAndMaterial={true}
        refetch={refetch}
        page="unit"
      />
    );
  }
  if (project.projectLotType === ProjectType.CommunityMultipleLot) {
    return (
      <TimeAndMaterialEditForm
        projectID={project.projectID}
        syncWithDux={project?.projectSyncWithDUX}
        projectTypeValue={project?.projectType ?? ""}
        singleOrMultiLots={data?.data.singleOrMultiLots}
        isTimeAndMaterial={false}
        refetch={refetch}
        page="unit"
      />
    );
  }
  if (project.projectCommunityType === ProjectType.ResidentialSingleLot) {
    return (
      <TimeAndMaterialEditForm
        projectID={project.projectID}
        syncWithDux={project?.projectSyncWithDUX}
        projectTypeValue={project?.projectType ?? ""}
        singleOrMultiLots={data?.data.singleOrMultiLots}
        isTimeAndMaterial={false}
        refetch={refetch}
        page="project"
      />
    );
  }
  if (
    project.projectLotType === ProjectType.CommunityScatteredLot ||
    project?.projectCommunityType === ProjectType.CommunityScatteredLot
  ) {
    return (
      scatteredSingleOrMultipleLot && (
        <SactteredLoTEditForm
          projectID={project?.projectID}
          syncWithDux={project?.projectSyncWithDUX}
          projectTypeValue={project?.projectType ?? ""}
          singleOrMultiLots={scatteredSingleOrMultipleLot || []}
          isTimeAndMaterial={false}
          refetch={refetch}
          page="unit"
        />
      )
    );
  }
  if (project.projectLotType === ProjectType.Buildings || project.projectCommunityType === ProjectType.Buildings) {
    return (
      <BuildingUnitsListForm
        refetch={refetch}
        page="unit"
        projectID={project.projectID}
        syncWithDux={project?.projectSyncWithDUX}
        projectTypeValue={project?.projectType ?? ""}
        projectBuildings={data?.data.projectBuildings}
      />
    );
  }
  return <>No data to display</>;
};
